import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

import { LicenseService } from './../../core/services/http-services/license.service';
import { EvaluationPeriodEnum } from './../../core/enums/evaluation-period.enum';
import { LicenseStatusModel } from '../../core/models/view-models/license-models/license-status.model';

@Component({
  selector: 'app-evaluation-period-expired',
  templateUrl: './evaluation-period-expired.component.html',
  styleUrls: ['./evaluation-period-expired.component.scss'],
})
export class EvaluationPeriodExpiredComponent {
  public form: UntypedFormGroup;
  public evaluationPeriodMode = EvaluationPeriodEnum.EvaluationPeriodInfo;
  public licenseStatus$: Subject<LicenseStatusModel> = new Subject();

  constructor(private readonly licenseService: LicenseService) {
    this.licenseStatus$ = this.licenseService.licenseStatusModel$;
  }
}
